import { Wrapper } from "./css/NavBarStyle";
import {
  FaAlignLeft,
  FaAlignRight,
  FaUserCircle,
  FaCaretDown,
} from "react-icons/fa";
import { ReadWellLogo } from "../assets/images";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { toggleSideBar, logoutUser } from "../slices/auth/authenticationSlice";

import AppLogo from "./AppLogo";

const NavBar = () => {
  const [showLogout, setShowLogout] = useState(false);
  const { credObj } = useSelector((store) => store.auth);
  const dispatch = useDispatch();

  const toggle = () => {
    dispatch(toggleSideBar());
  };
  return (
    <Wrapper>
      <div className="nav-center">
        <button type="button" className="toggle-btn" onClick={toggle}>
          <FaAlignRight />
        </button>
        <div>
          <AppLogo containerStyle="logo-container" textStyle="app-logo-text" />
          <h3 className="text-logo">Dashboard</h3>
        </div>
        <div className="btn-container">
          <button
            type="button"
            className="btn"
            onClick={(e) => {
              e.preventDefault();
              setShowLogout(!showLogout);
            }}
          >
            <FaUserCircle />
            Admin
            <FaCaretDown />
          </button>
          <div className={showLogout ? "dropdown show-dropdown" : "dropdown"}>
            <button
              type="button"
              className="dropdown-btn"
              onClick={() => {
                dispatch(logoutUser());
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
export default NavBar;
